import { FC, ReactElement } from 'react';

import { Bets } from '../../config/bets';
import { BettingActionConnected } from '../bettingAction/BettingActionConnected';

import styles from './bettingActionGridConnected.module.css';

export const BettingActionGridConnected: FC = (): ReactElement => {
  return (
    <div className={styles.bettingActionGrid}>
      <BettingActionConnected key={Bets.ONE} betCode={Bets.ONE} />
      <BettingActionConnected key={Bets.TWO} betCode={Bets.TWO} />
    </div>
  );
};
